import { Injectable } from '@angular/core';

import { RxStore } from '../application/rx-store';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  language = new RxStore<string>('');
}
